import React from 'react';
import { Box, Typography, Link } from '@mui/material';
import { useNavigate } from 'react-router-dom';

/**
 * Tutorial Tip Component
 * Common component to display tip about accessing tutorials page
 */
const TutorialTip = ({ sx = {}, onClose }) => {
  const navigate = useNavigate();

  const handleLinkClick = (e) => {
    e.preventDefault();
    // Close the dialog/modal if onClose callback is provided
    if (onClose) {
      onClose();
    }
    // Navigate to tutorials page
    navigate('/tutorials');
  };

  return (
    <Box 
      marginTop={3} 
      padding={2} 
      bgcolor="grey.100" 
      borderRadius={1}
      sx={sx}
    >
      <Typography variant="caption" color="text.secondary">
        <strong>Tip:</strong> You can find all tutorials anytime in{' '}
        <Link
          href="/tutorials"
          onClick={handleLinkClick}
          sx={{
            color: 'primary.main',
            textDecoration: 'none',
            fontWeight: 600,
            cursor: 'pointer',
            '&:hover': {
              textDecoration: 'underline',
            },
          }}
        >
          Profile → Tutorials
        </Link>
      </Typography>
    </Box>
  );
};

export default TutorialTip;

